import React, { useState } from 'react';
import { FolderSyncIcon, Loader2 } from 'lucide-react';
import { api_base_url } from "config";

const SyncTrButton = ({ onSyncComplete }) => {
  const [isSyncing, setIsSyncing] = useState(false);

  const handleSyncTr = async () => {
    setIsSyncing(true);
    try {
      const response = await fetch(`${api_base_url}/api/sync-tr-coupons/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      // Fallback sem credentials se der erro de CORS
      if (!response.ok && response.status !== 401) {
        const fallbackResponse = await fetch(`${api_base_url}/api/sync-tr-coupons/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
        });
        
        if (!fallbackResponse.ok) {
          throw new Error(`Erro HTTP: ${fallbackResponse.status}`);
        }
        
        const data = await fallbackResponse.json();
        handleSyncSuccess(data);
        return;
      }

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      handleSyncSuccess(data);
      
    } catch (error) {
      console.error('Erro ao sincronizar com TR:', error);
      
      if (error.message.includes('401')) {
        alert('Erro de autenticação. Verifique se você está logado.');
      } else if (error.message.includes('500')) {
        alert('Erro interno do servidor. Verifique os logs do backend.');
      } else {
        alert(`Erro ao sincronizar: ${error.message}`);
      }
    } finally {
      setIsSyncing(false);
    }
  };

  const handleSyncSuccess = (data) => {
    // Extrai informações da resposta
    const message = data.message || 'Sincronização concluída!';
    const totalUpdated = data.total_updated || 'N/A';
    const pagesProcessed = data.pages_processed || 'N/A';
    
    alert(`${message}\nCupons atualizados: ${totalUpdated}\nPáginas processadas: ${pagesProcessed}`);
    
    // Callback para atualizar dados se fornecido
    if (onSyncComplete) {
      onSyncComplete(data);
    }
  };

  return (
    <button 
      className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-blue-600 text-white hover:bg-blue-700 h-9 px-4 py-2"
      onClick={handleSyncTr}
      disabled={isSyncing}
      title="Sincroniza cupons locais com API do TR, marcando quais já foram publicados"
    >
      {isSyncing ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Sincronizando...
        </>
      ) : (
        <>
          <FolderSyncIcon className="mr-2 h-4 w-4" />
          Sync TR
        </>
      )}
    </button>
  );
};

export default SyncTrButton;